module.exports = __webpack_public_path__ + "img/local-icon-six.c5710c8b.png";